import { Stack, Typography } from '@mui/material';
import { Suspense } from 'react';

import { CircularBackdrop } from '../components/common/circularBackdrop/circularBackdrop';
import { Footer } from '../components/footer/footer';
import { Header } from '../components/header/header';

const NotFoundRoute = () => {
  return (
    <Suspense fallback={<CircularBackdrop />}>
      <div>
        <Stack
          height="100%"
          width="100%"
          alignItems="center"
          justifyContent="center"
        >
          <Stack
            height="100%"
            width="90%"
            direction="column"
            justifyContent="space-between"
            alignItems="flex-start"
            spacing={0}
            sx={{ bgcolor: 'rgb(241,241,241)' }}
          >
            <div style={{ width: '100%', minHeight: '83vh' }}>
              <Header />
              <Typography>404 Not Found</Typography>
            </div>
            <Footer />
          </Stack>
        </Stack>
      </div>
    </Suspense>
  );
};

export default NotFoundRoute;
